<template>
  <div class="tab">
    <div class="left">
      <div class="icon"></div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:String
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang='less'>
.tab {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 16px 12px;
  .left {
    display: flex;
    align-items: center;
    .icon {
      width: 2px;
      height: 12px;
      background-color: #2877FF;
      margin-right: 8px;
    }
    .title {
      font-weight: 500;
      font-size: 14px;
      color: #141B27;
    }
  }
}
</style>
